import { Component, Input, OnInit, AfterViewInit, OnDestroy } from '@angular/core'
import { DatePipe, AsyncPipe, DecimalPipe, NgTemplateOutlet } from '@angular/common'
import { FilteringSearchComponentBase } from '../filtering-search-component-base/filtering-search.component-base'
import { Subscription } from 'rxjs'
import { openClose, optionGroupTrigger } from '../../animations/open-close-animations'
import { NgSelectModule } from '@ng-select/ng-select'
import { DateRangeComponent } from '../date-range/date-range.component'
import { FormsModule } from '@angular/forms'
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons'
import { NgxSliderModule } from '@angular-slider/ngx-slider'


@Component({
    selector: 'local-filtering-search',
    templateUrl: '../filtering-search-component-base/filtering-search.component-base.html',
    styleUrls: ['../filtering-search-component-base/filtering-search.component-base.scss'],
    animations: [
        openClose,
        optionGroupTrigger,
    ],
    imports: [
        NgxBootstrapIconsModule,
        FormsModule,
        DateRangeComponent,
        NgSelectModule,
        NgxSliderModule,
        AsyncPipe,
        DecimalPipe,
        DatePipe,
        NgTemplateOutlet
    ]
})

export class LocalFilteringSearchComponent extends FilteringSearchComponentBase implements OnInit, AfterViewInit, OnDestroy {
    @Input() public documentsStore : any

    @Input() public embedded = false
    @Input() public contentSet = false

    loadSearchsubscription$: Subscription = new Subscription

    override ngOnInit(): void {
        super.ngOnInit()

        this.loadSearchsubscription$ = this.savedSearchService.searchToLoad$.subscribe(search => {
            this.loadSearch({ parameters: search.parameters ?? search }, true)
            this.makeSearchRequest()
        })
    }

    override ngOnDestroy() {
        super.ngOnDestroy()
        this.loadSearchsubscription$.unsubscribe()
    }

    override makeSearchRequest(startAt: number = 1) {
        if (startAt == 1) {
            this.documentsStore.removeAll()
        }

        super.makeSearchRequest(startAt)

        this.documentsStore.updateSearch({
            area: this.area,
            parameters: {
                ...this.search.parameters!,
                ...this.requiredFilters
            },
            order: this.search.order!,
        })
    }

    override saveSearch(type = 'search') {
        let name = this.createSearchName()

        let parameters = {
            ...this.search.parameters!,
            ...this.requiredFilters
        }

        let area = this.area
        if (this.requiredFilters?.['articleID']) {
            area = 'situations'
            type = 'followdocs'
            name = this.requiredFilters['name'] + ' - ' + name
            parameters['id'] = this.requiredFilters?.['articleID']
            parameters['area'] = 'situations'
        }

        this.savedSearchService.saveSearch({
            area,
            parameters: {
                area,
                parameters,
            },
            type,
            name,
        })
    }
    override clearSearch() {
        if (this.embedded) {
            this.resetSearch()
            this.makeSearchRequest()
        } else {
            super.clearSearch()
        }
    }
}